import React from 'react';
import * as dates from '@simplybenefits/sb-dates';
import { Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import Grid from "@mui/material/Grid";
import { useTheme } from '@mui/material/styles';

/**
 * 
 * @returns 
 */
const AdminSiteCoverageDisplay = ({
  coverage,
  hasWaived,
  meta
}) => {
  const theme = useTheme();
  const styles = {
    container: {
      flex: 1,
      minWidth: 290,
      border: "2px solid #F1F1F1",
      borderRadius: 5,
      backgroundColor: '#FFF'
    },
    row: {
      margin: "10px 0",
      padding: "0 20px",
      alignItems: "baseline"
    },
    block: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'column'
    },
    effectiveDateDisplay: {
      display: "flex",
      flexDirection: "row",
      alignItems: 'center',
      backgroundColor: theme.palette.primary.light,
      padding: 15,
      width: "95%",
      borderLeft: `3.5px solid ${theme.palette.primary.main}`
    }
  };
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    spacing: 2,
    sx: styles.row,
    wrap: "wrap"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    veryBold: true,
    medium: true
  }, i18n.t(tokens.labels.employees.coverageEffectiveDates), ":"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.criticalIllness)), /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.criticalIllness.benefitActive === 1 ? dates.getStartOfDay(coverage.criticalIllness.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.accidentalDeathAndDismemberment)), /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.deathDismemberment.benefitActive === 1 ? dates.getStartOfDay(coverage.deathDismemberment.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.dental)), hasWaived.includes('Dental') && meta.waiveFor === 'Self-Dependents' ? /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.dental.benefitActive === 1 ? i18n.t(tokens.labels.employees.waived) : i18n.t(tokens.titles.noCoverage)) : /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.dental.benefitActive === 1 ? dates.getStartOfDay(coverage.dental.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.dependentLife)), /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.dependentLife.benefitActive === 1 ? dates.getStartOfDay(coverage.dependentLife.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.drugs)), hasWaived.includes('Health') && meta.waiveFor === 'Self-Dependents' ? /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.drugs.benefitActive === 1 ? i18n.t(tokens.labels.employees.waived) : i18n.t(tokens.titles.noCoverage)) : /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.drugs.benefitActive === 1 ? dates.getStartOfDay(coverage.drugs.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.employeeAssistance)), /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.efap.benefitActive === 1 ? dates.getStartOfDay(coverage.efap.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.carrierBlock
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.virtualHealthCare)), coverage.virtualHealthcare.carrier && coverage.virtualHealthcare.benefitActive === 1 && /*#__PURE__*/React.createElement(Text, {
    tiny: true,
    light: true,
    margin: "0 0 0 5px"
  }, coverage.virtualHealthcare.carrier)), /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.virtualHealthcare.benefitActive === 1 ? dates.getStartOfDay(coverage.virtualHealthcare.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.carrierBlock
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.financialAwareness)), coverage.financialAwareness.carrier && coverage.financialAwareness.benefitActive === 1 && /*#__PURE__*/React.createElement(Text, {
    tiny: true,
    light: true,
    margin: "0 0 0 5px"
  }, coverage.financialAwareness.carrier)), /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.financialAwareness.benefitActive === 1 ? dates.getStartOfDay(coverage.financialAwareness.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.lifeInsurance)), /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.lifeInsurance.benefitActive === 1 ? dates.getStartOfDay(coverage.lifeInsurance.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.longTermDisability)), /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.ltd.benefitActive === 1 ? dates.getStartOfDay(coverage.ltd.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.shortTermDisability)), /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.std.benefitActive === 1 ? dates.getStartOfDay(coverage.std.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.majorMedical)), hasWaived.includes('Health') && meta.waiveFor === 'Self-Dependents' ? /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.majorMedical.benefitActive === 1 ? i18n.t(tokens.labels.employees.waived) : i18n.t(tokens.titles.noCoverage)) : /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.majorMedical.benefitActive === 1 ? dates.getStartOfDay(coverage.majorMedical.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.outOfCountry)), hasWaived.includes('Health') && meta.waiveFor === 'Self-Dependents' ? /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.outOfCountry.benefitActive === 1 ? i18n.t(tokens.labels.employees.waived) : i18n.t(tokens.titles.noCoverage)) : /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.outOfCountry.benefitActive === 1 ? dates.getStartOfDay(coverage.outOfCountry.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.paramedicals)), hasWaived.includes('Health') && meta.waiveFor === 'Self-Dependents' ? /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.paramedicals.benefitActive === 1 ? i18n.t(tokens.labels.employees.waived) : i18n.t(tokens.titles.noCoverage)) : /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.paramedicals.benefitActive === 1 ? dates.getStartOfDay(coverage.paramedicals.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.spendingAccounts)), /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.spendingAccounts.meta?.benefitActive === 1 ? dates.getStartOfDay(coverage.spendingAccounts.meta.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 3,
    style: {
      padding: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.titles.vision)), hasWaived.includes('Health') && meta.waiveFor === 'Self-Dependents' ? /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.vision.benefitActive === 1 ? i18n.t(tokens.labels.employees.waived) : i18n.t(tokens.titles.noCoverage)) : /*#__PURE__*/React.createElement(Text, {
    small: true
  }, coverage.vision.benefitActive === 1 ? dates.getStartOfDay(coverage.vision.eligibilityPeriodEnds, 'll', i18n.locale) : i18n.t(tokens.titles.noCoverage)))));
};
export default AdminSiteCoverageDisplay;